import { render, staticRenderFns } from "./BookingShiftForm.vue?vue&type=template&id=58b3a3ee&"
import script from "./BookingShiftForm.vue?vue&type=script&lang=js&"
export * from "./BookingShiftForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports